import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useUser } from "@/contexts/user-context"
import { getCurrentTenantId } from "@/lib/tenant"
import { MainLandingPage } from "@/components/landing/main-landing-page"
import { TenantLandingPage } from "@/components/landing/tenant-landing-page"

export default function Home() {
  const navigate = useNavigate()
  const { isAuthenticated } = useUser()
  const [tenantId, setTenantId] = useState<string | null>(null)
  const [isChecking, setIsChecking] = useState(true)

  useEffect(() => {
    // Check authentication and tenant status
    const checkStatus = () => {
      // If authenticated, redirect to dashboard
      if (isAuthenticated) {
        console.log('[Home] User authenticated, redirecting to dashboard')
        navigate("/dashboard")
        return
      }

      // Check for tenant from subdomain OR localStorage
      const tenant = getCurrentTenantId()
      console.log('[Home] Tenant detected:', tenant || 'none (showing main landing page)')
      setTenantId(tenant)
      setIsChecking(false)
    }

    checkStatus()
  }, [isAuthenticated, navigate])

  // Show loading state while checking
  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  // Show tenant landing page if on a tenant subdomain
  if (tenantId) {
    return <TenantLandingPage />
  }

  // Show main landing page for main domain
  return <MainLandingPage />
}
